import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CLIENT_ID } from "./utils/env";
import { ModalPortal } from "./portal";
import { WeeklyRewardsPreview } from "./dev/WeeklyRewardsPreview";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <GoogleOAuthProvider clientId={CLIENT_ID()}>
    <React.StrictMode>
      {process.env.NODE_ENV === "development" &&
      window.location.pathname === "/__preview/weekly-rewards" ? (
        <WeeklyRewardsPreview />
      ) : (
        <>
          <App />
          <ModalPortal />
        </>
      )}
    </React.StrictMode>
  </GoogleOAuthProvider>
);
